<template>
    <div class="product-insights" style="margin-bottom: 20px;">
      <carousel :per-page="5" :navigationEnabled="true" :mouse-drag="false">
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Conversion Rate:</h3>
              </div>
              <div class="col-md-6">
                <h2 style="text-align: left;">{{ activitiesCompletedNumber }}</h2>
              </div>
              <div class="col-md-6">
                 <h5 class="brown_line">{{ activitiesCompletedPercentage ? Math.ceil(activitiesCompletedPercentage) : 0 }}%</h5>
              </div>
              </div>
            </div>
        </slide>
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Purchase Rate:</h3>
              </div>
              <!-- <div class="col-md-6">
                <h2 style="text-align: left;">{{ SalesConversionRateNumber }}</h2>
              </div> -->
              <div class="col-md-6">
                 <h5>{{ SalesConversionRate ? Math.ceil(SalesConversionRate) : 0 }}%</h5>
              </div>
              </div>
            </div>
        </slide>
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">In-Store Shop:</h3>
              </div>
              <!-- <div class="col-md-6">
                <h2 style="text-align: left;">{{ upsellRatioNumber }}</h2>
              </div> -->
              <div class="col-md-6">
                 <h5>{{ upsellRatio ? Math.ceil(upsellRatio) : 0 }}%</h5>
              </div>
              </div>
            </div>
        </slide>
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Survey Purchase Intent:</h3>
              </div>
              <!-- <div class="col-md-6">
                <h2 style="text-align: left;">{{ purchaseIntentSummaryYes }}</h2>
              </div> -->
              <div class="col-md-6">
                 <h5>{{ purchaseIntentSummaryTotal ? Math.ceil(purchaseIntentSummaryTotal) : 0 }}%</h5>
              </div>
              </div>
            </div>
        </slide>
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Reimbursements:</h3>
              </div>
              <div class="col-md-6">
                <h2 style="text-align: left;">${{ byMeCreditConsumed }}</h2>
              </div>
              <!-- <div class="col-md-6">
                 <h5>${{ byMeCreditConsumed }}</h5>
              </div> -->
              </div>
            </div>
        </slide>
        <slide v-if="shopIntentSummaryYes != null">
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-8">
                <h3>Survey Shop Intent:</h3>
                <h2>{{ shopIntentSummaryYes }}</h2>
              </div>
              <div class="col-md-4">
                 <h5>{{ shopIntentSummaryTotal ? Math.ceil(shopIntentSummaryTotal) : 0 }}%</h5>
              </div>
              </div>
            </div>
        </slide>
        <!-- <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3>Total Numbers Of Survey Responses</h3>
                <h2>{{ totalResponses }}</h2>
              </div>
              </div>
            </div>
        </slide> -->
        <!-- <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3>Total Numbers Of Photos</h3>
                <h2>{{ totalPhotos }}</h2>
              </div>
              </div>
            </div>
        </slide> -->
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Selfies with Product:</h3>
              </div>
              <div class="col-md-6">
                <h2 style="text-align: left;">{{ totalSelfies }}</h2>
              </div>
            </div>
          </div>
        </slide>
        <!-- <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-8">
                <h3>Activities with Issues</h3>
                <h2>{{ activitiesWithIssuesNumber }}</h2>
              </div>
              <div class="col-md-4">
                 <h5>{{ activitiesWithIssuesPercentage ? Math.ceil(activitiesWithIssuesPercentage) : 0 }}%</h5>
              </div>
              </div>
            </div>
        </slide> -->
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-8">
                <h3 style="text-align: left;">Issues:</h3>
                <h2 style="text-align: left;font-size: 18px;margin-top: 20px; margin-bottom: 0px;">{{ activitiesWithIssuesNumber }}</h2>
              </div>
              <!-- <div class="col-md-4">
                 <h5>{{ activitiesWithIssuesPercentage ? Math.ceil(activitiesWithIssuesPercentage) : 0 }}%</h5>
              </div> -->
              </div>
            </div>
        </slide>
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Repeat Locations:</h3>
              </div>
              <div class="col-md-6">
                <h2 style="text-align: left;">{{ repeatLocations }}</h2>
              </div>
              </div>
            </div>
        </slide>
        <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3 style="text-align: left;">Average Lead Response Time:</h3>
              </div>
              <div class="col-md-12">
                <h2 style="text-align: left;">{{ AverageLeadResponseTime}}</h2>
              </div>
              </div>
            </div>
        </slide>
        <!-- <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3>Fastest Lead Response Time</h3>
                <h2>{{ FastestLeadResponseTime }}</h2>
              </div>
              </div>
            </div>
        </slide> -->
        <!-- <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3>Trips Frequency</h3>
                <h2>{{ tripsFrequency }}</h2>
              </div>
              </div>
            </div>
        </slide> -->
        <!-- <slide>
          <div class="metrics-box">
            <div class="row">
              <div class="col-md-12">
                <h3>Basket Size</h3>
                <h2>{{ basketSize }}</h2>
              </div>
              </div>
            </div>
        </slide> -->
      </carousel>
      <!-- <h4 v-show="loading" style="text-align: center;">Loading Products Insights...</h4> -->
    </div>

</template>
<script>
import { Carousel, Slide } from 'vue-carousel'
export default {
  name: 'ProductInsights',
  components: {
    Carousel,
    Slide
  },
  props: ['brandId', 'activitiesCompletedNumber', 'totalSelfies', 'totalResponses', 'totalPhotos', 'purchaseIntentSummaryTotal', 'shopIntentSummaryTotal', 'shopIntentSummaryYes', 'purchaseIntentSummaryYes', 'activitiesWithNotesPercentage', 'activitiesWithNotesNumber', 'upsellRatio', 'activitiesCompletedPercentage', 'activitiesWithIssuesNumber', 'activitiesWithIssuesPercentage', 'repeatLocations', 'byMeCreditConsumed', 'AverageLeadResponseTime', 'FastestLeadResponseTime', 'tripsFrequency', 'basketSize', 'SalesConversionRateNumber', 'SalesConversionRate', 'upsellRatioNumber'],
  data: function () {
    return {
      loading: true,
      localTime: '',
      selfies: [],
      image: '',
      userName: '',
      storeName: '',
      storeAddress: '',
      slickOptions: {
        slidesToShow: 3
      }
    }
  },
  methods: {
    next () {
      this.$refs.slick.next()
    },

    prev () {
      this.$refs.slick.prev()
    },

    reInit () {
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      })
    },

    handleAfterChange (event, slick, currentSlide) {
      console.log('handleAfterChange', event, slick, currentSlide)
    },
    handleBeforeChange (event, slick, currentSlide, nextSlide) {
      console.log('handleBeforeChange', event, slick, currentSlide, nextSlide)
    },
    handleBreakpoint (event, slick, breakpoint) {
      console.log('handleBreakpoint', event, slick, breakpoint)
    },
    handleDestroy (event, slick) {
      console.log('handleDestroy', event, slick)
    },
    handleEdge (event, slick, direction) {
      console.log('handleEdge', event, slick, direction)
    },
    handleInit (event, slick) {
      console.log('handleInit', event, slick)
    },
    handleReInit (event, slick) {
      console.log('handleReInit', event, slick)
    },
    handleSetPosition (event, slick) {
      console.log('handleSetPosition', event, slick)
    },
    handleSwipe (event, slick, direction) {
      console.log('handleSwipe', event, slick, direction)
    },
    handleLazyLoaded (event, slick, image, imageSource) {
      console.log('handleLazyLoaded', event, slick, image, imageSource)
    },
    handleLazyLoadError (event, slick, image, imageSource) {
      console.log('handleLazeLoadError', event, slick, image, imageSource)
    },

    getBrandSocialSelfies () {
      this.$store.dispatch('getBrandSocialSelfies', this.brandId)
        .then(
          (response) => {
            console.log(response.body)
            this.selfies = response.body
            this.loading = false
            this.showLocaleTime()
            this.image = this.selfies[0]['image'] + '?width=300'
            this.storeAddress = this.selfies[0]['address']
            this.userName = this.selfies[0]['name']
            this.storeName = this.selfies[0]['store']
          }
        )
    },
    showLocaleTime: function () {
      var here = this
      let counter = 1
      setInterval(function () {
        here.image = here.selfies[counter]['image'] + '?width=300'
        here.storeAddress = here.selfies[counter]['address']
        here.userName = here.selfies[counter]['name']
        here.storeName = here.selfies[counter]['store']
        counter++
        if (counter === (here.selfies.length - 1)) {
          counter = 0
        }
      }, 5000)
    }
  },

  mounted () {
    // this.getBrandSocialSelfies()
  },
  watch: {

  }
}
</script>
<style>
.VueCarousel-pagination{
  display: none;
}
.metrics-box {
    width: 94%;
    margin: 10px 3%;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.4);
    padding: 10px;
    text-align: center;
    min-height: 116px;
}
.metrics-box h3{
    font-size: 16px;
    color: #000;
    line-height: 23px;
    margin-top: 5px;
}
.metrics-box h2{
    font-size: 20px;
    color: #000;
    line-height: 23px;
    min-height: 23px;
    margin-top: 15px;
}
.metrics-box h5{
    background: #d2eadd;
    width: 52px;
    line-height: 50px;
    border-radius: 100%;
    margin-top: 0px;
    border: 2px solid #12db6d;
    font-size: 16px;
    margin: 0 auto;
}
.metrics-box .col-md-8{
    padding-right: 0px;
}
.brown_line{
  border: 2px solid #641c44 !important;
  background: #DCC8D3 !important;
}
</style>
